export default __webpack_public_path__ + "static/media/WaitingForLD.6436cf87.png";